import React, { useContext, useState } from 'react';
import {
    FieldControl, PhoneInput, Label, Alert, Tooltip, TooltipButton, GlyphInfo
} from '@americanexpress/dls-react';
import UserContext from '../ContextComponent/UserContext';
import { CONSTANTS } from '../../constants';

function Mobile({ format, type }) {

    const [MobileLengthError, setMobileLengthError] = useState(false);
    const [AlternateMobileLengthError, setAlternateMobileLengthError] = useState(false);
    const [PatternMatchError, setPatternMatchError] = useState(false);
    const { formData, setFormData } = useContext(UserContext);
    const { errorData, setErrorData } = useContext(UserContext);

    const onMobileBlur = (event) => {
        if (event.target.value.length === 0) {
            setErrorData({ ...errorData, mobileNumberRequired: true, altNumberRequired: true });
        }
        else if (event.target.value.length < 10 && `${type}` !== "Alternate") {
            setMobileLengthError(true);
            setErrorData({ ...errorData, mobileNumberRequired: false });
        }
        else if (event.target.value.length < 10 && `${type}` === "Alternate") {
            setAlternateMobileLengthError(true);
            setErrorData({ ...errorData, mobileNumberRequired: false, altNumberRequired: false });
        }
        else {
            setMobileLengthError(false);
            setErrorData({ ...errorData, mobileNumberRequired: false, altNumberRequired: false });
            setAlternateMobileLengthError(false);
        }
    };
    const validateMobile = (event) => {

        if (type !== 'Alternate') {
            if (event.target.value !== '' && event.target.value.length === 10) {
                const result = !CONSTANTS.validation.mobilePattern.test(event.target.value);
                setPatternMatchError(result);
                setErrorData({ ...errorData, mobileNumberRequired: false });
                setFormData((prevState) => { return { ...prevState, mobileNumber: event.target.value } });
            }
            else {
                setPatternMatchError(false);
                setErrorData({ ...errorData, mobileNumberRequired: false });
                setFormData((prevState) => { return { ...prevState, mobileNumber: event.target.value } });
            }
        }
        else {
            if (event.target.value !== '' && event.target.value.length === 10) {
                const result = !CONSTANTS.validation.mobilePattern.test(event.target.value);
//                setPatternMatchError(result);
                setErrorData((prevState) => { return { ...prevState, altNumberRequired: false } });
                setFormData((prevState) => { return { ...prevState, alternateMobileNumber: event.target.value } });
            }
            else {
                setPatternMatchError(false);
                setErrorData((prevState) => { return { ...prevState, altNumberRequired: false } });
                setFormData((prevState) => { return { ...prevState, alternateMobileNumber: event.target.value } });
            }
        }
    }

    return (
        <div>
            <FieldControl>
                <Label id={`${type}MobileNumber-label`} htmlFor={`${type}MobileNumber`} className="label-1" >
                    {type === "Alternate" ? "Alternative Phone Number" : "Mobile Number"}&nbsp;
                </Label>
                {type === "Alternate" &&
                    <Tooltip
                        id="tooltip-info-right"
                        triggerElement={(
                            <TooltipButton info={true} icon={<GlyphInfo />} />
                        )}
                        placement="top"
                        info={true}
                    >
                        Please provide your home/office landline or alternate mobile number.
                    </Tooltip>
                }
                <PhoneInput
                    id={`${type}MobileNumber`}
                    name={`${type}MobileNumber`}
                    locale="es-IN"
                    country="India"
                    callingCode={91}
                    value={type === "Alternate" ? formData.alternateMobileNumber : formData.mobileNumber}
                    phoneFormat={`${format}`}
                    showFlag={true}
                    onBlur={onMobileBlur}
                    onChange={validateMobile}
                    showCallingCode={true}
                    showStateIcon={false}
                    theme={{ 'div:last-child': { width: '100%' } }}
                />
                {type === "Alternate" && <p>Please provide your home/office landline or alternate mobile number.</p>}
            </FieldControl>
            {`${type}` !== "Alternate" &&
                <Alert id="MobileNull-alert" show={errorData.mobileNumberRequired}>Please Enter Mobile Number</Alert>
            }
            {`${type}` === "Alternate" &&
                <Alert id="AlternateMobileNull-alert" show={errorData.altNumberRequired}>Please enter your alternate phone number.
                </Alert>
            }
            <Alert id="MobileLength-alert" show={MobileLengthError}>Please ensure Mobile number contains digits only (0-9) and contain 10 digits. You will need to provide a mobile number so that we can process your application.</Alert>
            <Alert id="AlternateMobileLength-alert" show={AlternateMobileLengthError}>Please enter a valid alternate phone number</Alert>
            <Alert id="PatternMatch-alert" show={PatternMatchError}>The mobile number should start with "6",7, 8 or 9 only.</Alert>
        </div>
    );
}
export default Mobile;